/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { getApiEndpoint } from '../utils/getApiEndpoint';

// Set to `wss://localhost:8080` during development
export const wsServer = `wss://${getApiEndpoint('/').split('://')[1]}`;
